import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { FormlyModule } from "@ngx-formly/core";
import { FlexModule } from "@vp/shared/directives/flex";
import { ESignatureDialogComponent } from "./e-signature-dialog/e-signature-dialog.component";
import { UserESignatureComponent } from "./user-e-signature.component";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    FormlyModule.forChild({
      types: [{ name: "e-signature", component: UserESignatureComponent }]
    }),
    FlexModule
  ],
  declarations: [UserESignatureComponent, ESignatureDialogComponent],
  exports: [UserESignatureComponent]
})
export class UserESignatureModule {}
